import { get } from "../../../utils/object-helpers";

<if(get(input, "name", null) === 'AUTHORIZED_SELLER')>
    <div class="str-icon">
        <ebay-authenticity-guarantee-24-fit-icon/>
    </div>
</if>
